<!--
文档创作统计
@author 姚润发
@created 2021/02/02 17:36
-->
<template>
	<lnk-panelfolder title="文档创作统计" folder>
		<el-row>
			<el-col :span="12" class="access-count-wrapper">
				<div class="access-count-title">
					<h4>文档总数</h4>
					<span class="access-count-title__right">{{creationList.reduce((total, item) => total + item.count, 0)}}</span>
				</div>
				<hr>
				<p v-for="item in creationList" class="access-count-item" @click="openUserMenu(item.author || '未知作者')">
					{{item.author || '未知作者'}}
					<span class="access-count-item__right">{{item.count}}</span>
				</p>
			</el-col>
		</el-row>
	</lnk-panelfolder>
</template>

<script>
  export default {
    name: "creation-statistics",
    data() {
      return {
        creationList: []
	  }
    },
    methods: {
      openUserMenu(name) {
        this.$nav.openTab({
          id: `${name}doc-components/page/my-menu.vue`,
          title: `${name}的文档`,
          path: 'my-menu',
          param: {
            onlyMyDocFlag: true,
            fstName: name,
          }
        });
      }
    },
    created() {
      this.creationList = this.$lv.$documentAccessService.countPageByAuthor();
    }
  }
</script>

<style scoped lang="scss">
	@import './statistics';
</style>
